import { render, staticRenderFns } from "./addStudentDialog.vue?vue&type=template&id=3e0210c2&scoped=true&"
import script from "./addStudentDialog.vue?vue&type=script&lang=js&"
export * from "./addStudentDialog.vue?vue&type=script&lang=js&"
import style0 from "./addStudentDialog.vue?vue&type=style&index=0&id=3e0210c2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0210c2",
  null
  
)

export default component.exports